<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadSummary="loadSummary"
      @loadUser="loadUser"
      :includeAdmin="true"
    ></results-bar>
    <results-summary v-if="summary" :id="doc.id"></results-summary>
    <results-user
      v-if="!summary"
      :uid="currentUser"
      :id="doc.id"
    ></results-user>
    <pre>{{ summary }}</pre>
  </div>
</template>

<script>
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary,
} from "@/components/results/today-tomorrow";

export default {
  name: "ResultProposition",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary,
  },
  mounted() {},
  computed: {},
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
  },
};
</script>
